import {DatePipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {PainelinsumoService} from '../../../services/painelinsumo.service';
import {ToastService} from '../../../services/toast.service';
import {Instancia} from '../../../types/Instancia.type';
import { IntegradorService } from '../../../services/integrador.service';
import { Empresa } from '../../../types/Empresa.type';

interface Situacao {
  id: string;
  situacao: string;
}

interface Relatorio {
  id: string;
  relatorio: string;
}

interface Solicitacao {
  relatorio: string,
  dataInicial: string,
  dataFinal: string,
  instancias: string,
  situacao: string,
}

@Component({
  selector: 'painelinsumo-relatorios',
  templateUrl: './relatorios.component.html',
  styleUrl: './relatorios.component.css',
  providers: [DatePipe]
})
export class RelatoriosComponent implements OnInit {

  loading: boolean = false;
  rangeDates!: string;
  instancias: Instancia[] = [];
  instanciaSelecionada!: string;
  dataInicio!: string
  dataFim!: string
  situacoes: Situacao[] | undefined;
  situacaoSelecionada: Situacao | undefined;

  relatorios: Relatorio[] | undefined;
  relatorioSelecionado: Relatorio | undefined;

  gerado: boolean = false;


  empresas: Empresa[] = [];

  constructor(private painelInsumoService: PainelinsumoService, private toastService: ToastService, private datePipe: DatePipe, private integradorService: IntegradorService) {
  }

  ngOnInit() {
    this.buscaEmpresas();
    
    this.situacoes = [
      {id: '', situacao: 'Todas'},
      {id: 'F', situacao: 'Fechada'},
      {id: 'A', situacao: 'Aberta'}
    ];

    this.situacaoSelecionada = {id: '', situacao: 'Todas'};

    this.relatorios = [
      {id: 'ordem', relatorio: 'Por Ordem'},
      {id: 'consulta-estoque-completa', relatorio: 'Estoque Insumos ERP'},
      {id: 'consulta-reservas', relatorio: 'Consultar Reservas'},
    ]

    this.relatorioSelecionado = {id: 'ordem', relatorio: 'Por Ordem'}
  }

   buscaEmpresas(){
      this.integradorService.getEmpresas().subscribe({
        next: (data) => {
          this.empresas = data

          this.empresas.forEach(empresa => {
            let instancia: Instancia = {id: empresa.instancia, nome: empresa.instancia}
            
            this.instancias.push(instancia);

          })
        },
        error: (error) => {
          console.error(error)
          this.toastService.erro("Erro", error.error.message)
        }
      })
    }

  onDateChange(event: any) {
    this.dataInicio = this.getDataPipeTransForm(this.rangeDates[0]);
    this.dataFim = this.getDataPipeTransForm(this.rangeDates[1]);
  }

  getDataPipeTransForm(data: string): string | "" {
    return this.datePipe.transform(data, 'dd/MM/yyyy') || "";
  }

  gerarRelatorio() {
    this.gerado = true;

    if (this.situacaoSelecionada != undefined && this.relatorioSelecionado != undefined) {
      this.loading = true

      if (this.dataFim == "") this.dataFim = this.dataInicio

      let solicitacao: Solicitacao = {
        situacao: this.situacaoSelecionada.id,
        relatorio: this.relatorioSelecionado.id,
        dataInicial: this.dataInicio,
        dataFinal: this.dataFim,
        instancias: this.instanciaSelecionada
      }

      this.painelInsumoService.exportarRelatorio(solicitacao).subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a')
          a.href = url
          a.download = 'data.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          this.loading = false;
        },
        error: (err) => {
          if (err.error instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorResponse = JSON.parse(reader.result as string);
                this.toastService.erro("Erro", "Erro ao gerar o relatório: " +
                  (errorResponse.message || errorResponse.error || "Erro desconhecido"));
              } catch (e) {
                this.toastService.erro("Erro", "Erro ao gerar o relatório");
              } finally {
                this.loading = false;
              }
            };
            reader.readAsText(err.error);
          } else {
            this.toastService.erro("Erro", "Erro ao gerar o relatório: " +
              (err.error?.message || err.message || "Erro desconhecido"));
            this.loading = false;
          }
        },
      });
    } else {
      this.toastService.info("Campos obrigatórios", "Necessário selecionar os campos obrigatórios")
    }

  }

}
